import React from 'react';

const ManagementTeam = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        style={{ backgroundImage: "url('assets/img/bg/breadcumb-bg.jpg')" }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Management Team</h1>
            <ul className="breadcumb-menu">
              <li><a href="/">Home</a></li>
              <li>Management Team</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="space-top">
        <div className="container">
          <div className="team-details">
            <div className="row mb-3 mb-xl-5 pb-xl-4">
              <div className="col-md-6">
                <div className="about-card-img mb-40 mb-xl-0">
                  <img src="assets/img/team/wisani.jpg" alt="wisani maringa" />
                </div>
              </div>
              <div className="col-xl-6 ps-3 ps-xl-5 align-self-center">
                <div className="team-about">
                  <h3 className="team-about_title">Wisani Maringa</h3>
                  <p className="team-about_desig">Director</p>
                  <p className="team-about_text mb-25">
                    Matriculated in 1999 at Bankuna high school, B-Tech Degree in Biotechnology from Vaal University of Technology. In 2008 she obtained SAMTRAC, in 2011 did TQM and OHSAS 18001 Implementation with Advantage ACT and Obtained OHSAS 18001 LEAD AUDITORS COURSE from DQS in 2013.
                  </p>
                  <p>
                    Wisani has over a decade Experience in Health and Safety, specializing in Quality Management System (ISO 9001:2008), Environmental Management system (ISO 14001), Safety management system (OHSAS 18001:2007), Risk assessment, Safety operating procedure, Auditing, Legal compliance audits and Gap Analysis Audits.
                  </p>
                  <p>
                    Wisani has worked for the following Companies: Distell as a Lab Analyst, Protea Coin as a National SHE Coordinator, ZF Friedrichshafen as a Senior SHEQ Specialist and Zest WEG Group as a SHEQ Manager.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="team-details">
            <div className="row mb-3 mb-xl-5 pb-xl-4">
              <div className="col-md-6">
                <div className="about-card-img mb-40 mb-xl-0">
                  <img src="assets/img/team/Andrew.jpg" alt="andrew maringa" />
                </div>
              </div>
              <div className="col-xl-6 ps-3 ps-xl-5 align-self-center">
                <div className="team-about">
                  <h3 className="team-about_title">Andrew Maringa</h3>
                  <p className="team-about_desig">Operations Manager/IT Manager</p>
                  <p className="team-about_text mb-25">
                    Andrew has got over 10 years working experience in the IT industry and he has worked for the following Companies: Paracon as an IT Technician, Deloitte and Touché as an IT Support Technician, Mthombo IT Services (EOH) as an IT Support Engineer, Dimension Data as a Network Support Engineer during the historic first presidential elections in DRC in year 2006, Bytes Technology as a Senior IT Engineer, Siemens as a Senior Support Engineer, Medscheme as a Senior Applications and Systems Specialist, Multichoice as an IT BackOffice Engineer and Helios IT Solutions as Senior Servers Specialist.                  </p>
                  <p>
                    Andrew Maringa founded and Launched Tendai ICT in 2014 and he is currently a Managing Director of Tendai ICT.  
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ManagementTeam;
